import React from 'react';
// components
import Icon from '../../../components/Icon/Icon';
// styles
import styles from './Pricing.mod.css';
import { SUBSCRIPTION_PRICE } from '../Billing';

const advantages = [
  'Access to All Modules',
  'Access to Recovery Plan',
  'Access to All Check-ins',
  'Access to Resources',
  'Access to All Features',
];

const Pricing = () => (
  <div className={styles.container}>
    <div className={styles.content}>
      <p className={styles.title}>MONTHLY</p>
      <div>
        <p className={styles.price}>
          {SUBSCRIPTION_PRICE}
          <span>$</span>
        </p>
      </div>
      <h4 className={styles.description}>
        No Curing Period - End whenever you want
      </h4>
      <div>
        {advantages.map((item, index) => (
          <div className={styles.advantage} key={index}>
            <Icon type="check" />
            <p>{item}</p>
          </div>
        ))}
      </div>
    </div>
  </div>
);

export default Pricing;



// WEBPACK FOOTER //
// ./src/containers/Billing/components/Pricing.jsx